import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["form", "customDates"]

  connect() {
    console.log("ActivityFiltersController connected")
  }

  submitForm(event) {
    event.preventDefault()
    console.log("Submitting activity filters")
    
    // Close the drawer
    this.closeDrawer()
    
    // Get form data
    const formData = new FormData(this.formTarget)
    const params = new URLSearchParams(formData)
    
    // Remove page parameter to start from page 1
    params.delete('page')
    
    // Make a fetch request to get turbo_stream response
    fetch(`${window.location.pathname}?${params}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Use Turbo to process the turbo_stream response
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Filter request failed:', error)
    })
  }

  clearFilters(event) {
    event.preventDefault()
    console.log("Clearing activity filters")
    
    // Clear all checkboxes
    this.formTarget.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false
    })
    
    // Clear all radio buttons
    this.formTarget.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.checked = false
    })
    
    // Clear date inputs
    this.formTarget.querySelectorAll('input[type="date"]').forEach(dateInput => {
      dateInput.value = ''
    })
    
    // Hide custom dates
    if (this.hasCustomDatesTarget) {
      this.customDatesTarget.style.display = 'none'
    }
    
    // Submit the cleared form
    this.submitForm(event)
  }

  toggleCustomDates(event) {
    if (this.hasCustomDatesTarget) {
      if (event.target.checked) {
        this.customDatesTarget.style.display = 'block'
      } else {
        this.customDatesTarget.style.display = 'none'
      }
    }
  }

  closeDrawer() {
    const drawerToggle = document.getElementById('activity-filters-drawer')
    if (drawerToggle) {
      drawerToggle.checked = false
    }
  }
}

